module.exports = __webpack_public_path__ + "media/images/list_mizu-d83a58be9e7389ec3a58ca58737e5b88.gif";